export const ALLOWED_PAYMENT_TYPES = [
    'PIX',
    // 'CREDIT_CARD', // suspenso temporariamente - 1217037413962774 - 2026-07-30 — reativar: descomentar esta linha
] as const
